module.exports = __webpack_public_path__ + "img/about-us-video.1d82130d.jpg";